import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const sel = "h-9 w-full rounded-md border border-slate-300 bg-white text-sm px-2";
const ISO = /^\d{4}-\d{2}-\d{2}$/;

export const FieldInput = ({ field, value = "", onChange, testid, compact, disabled }) => {
  const v = value ?? "";
  if (field.type === "select") {
    return (
      <select className={sel} value={v} disabled={disabled} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
        <option value="">—</option>
        {!field.options.includes(v) && v && <option value={v}>{v}</option>}
        {field.options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }
  if (field.type === "textarea" && !compact) {
    return <Textarea rows={4} value={v} disabled={disabled} onChange={(e) => onChange(e.target.value)} className="bg-white" data-testid={testid} />;
  }
  const type = field.type === "date" && (!v || ISO.test(v)) ? "date" : "text";
  return <Input type={type} inputMode={field.type === "number" ? "decimal" : undefined} value={v} disabled={disabled}
    onChange={(e) => onChange(e.target.value)} className={`bg-white ${compact ? "h-8 text-xs min-w-[120px]" : ""}`} data-testid={testid} />;
};
